import { Signal } from '@angular/core';
import { DataPerson } from '@shared/components/navbar/data-access';
import { IUiClientSettings } from './ui-client-settings.model';

export interface IShortcutItem {
  Identifier: string;
}

export interface IDeckItem {
  Identifier: string;
  PositionX: number;
  PositionY: number;
}

export interface IValidationResult {
  IsValid: boolean;
  Errors: string[];
  RuleSetsExecuted: string | null;
}

export interface IUserSettings {
  UserSettingsId: string;
  Language: string;
  Decks: IDeckItem[];
  FavoriteMenus: IShortcutItem[];
  Sidebar: IShortcutItem[];
  Operation: any;
  ValidationResult: IValidationResult;
  IsValid: boolean;
  /** UI client settings stored as JSON - contains elasticSearch, sidebar preferences */
  UiClientSettings?: IUiClientSettings | string;
}

export type TShortcutState = 'default' | 'disabled';
export type TUnsavedData = {
  id?: string;
  type: EShortcutIdentifier;
  name: string;
  value: any;
  action: () => void;
};
export type TShortcutOption = {
  id: string;
  description: string;
  isChecked: boolean;
  state: TShortcutState;
  identifier: string;
  tabs?: Signal<TUnsavedData[]>;
};

export enum EShortcutIdentifier {
  NewClient = 'new-client',
  NewSubscription = 'new-subscribe',
  LaunchService = 'launch-service',
  NewSale = 'new-sale',
  NewVisitor = 'new-visitor',
  MakePayment = 'make-payment',
  MakeReceipt = 'make-receipt',
  NewAssessment = 'new-assessment',
  Consumption = 'consumption',
  NewGraduation = 'new-graduation',
  NewPause = 'new-pause',
  NewContract = 'new-contract',
}

export const shortcutsHiddenRoutes = [];

export const iconMap: Record<EShortcutIdentifier, string> = {
  [EShortcutIdentifier.NewClient]: 'circle-user',
  [EShortcutIdentifier.NewSubscription]: 'memo-circle-check',
  [EShortcutIdentifier.LaunchService]: 'heart-partner-handshake',
  [EShortcutIdentifier.NewSale]: 'box-open',
  [EShortcutIdentifier.NewVisitor]: 'id-card-clip-alt',
  [EShortcutIdentifier.MakePayment]: 'bill-arrow',
  [EShortcutIdentifier.MakeReceipt]: 'bill-arrow -scale-y-100',
  [EShortcutIdentifier.NewAssessment]: 'clipboard-check',
  [EShortcutIdentifier.Consumption]: 'bolt',
  [EShortcutIdentifier.NewGraduation]: 'graduation-cap',
  [EShortcutIdentifier.NewPause]: 'lock',
  [EShortcutIdentifier.NewContract]: 'file-signature',
};

export interface SuperSearchPersonParams {
  q: string;
  page?: number;
  registrationType?: string;
  isActive?: boolean;
}
export interface SuperSearchPersonResponse {
  results: DataPerson[];
  total?: number;
  page?: number;
  pages?: number;
}
